<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KNIp5X/tc-custom/9781605098975.jpg?1735039232466" alt="This image is the cover for the book Solving Tough Problems"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Solving Tough Problems
      </h1>
      <p class="bookDescription body article font2">
        <b>“This breakthrough book addresses the central challenge of our time: finding a way to work together to solve the problems we have created.” —Nelson Mandela</b><br/>  <br/> Adam Kahane has worked on some of the toughest, most complex problems in the world. He started out as an expert analyst and advisor to corporations and governments, convinced of the need to calculate “the one right answer.” After an unexpected experience in South Africa during the transition away from apartheid, he got involved in facilitating a series of extraordinary high-conflict, high-stakes problem-solving efforts: in Colombia during the civil war, in Argentina during the collapse, in Guatemala after the genocide, in Israel, Northern Ireland, Cyprus, and the Basque Country. Through these experiences, he learned to create environments that enable new ideas and creative solutions to emerge even in the most stuck, polarized contexts. Here Kahane tells his stories and distills from them an approach all of us can use to solve our own toughest problems—at home, at work, in our communities, and in national and international affairs.<br/>  <br/><b>“Thought-provoking (occasionally verging on spiritual) discourse on handling difficult situations gracefully, productively and calmly.” —<i>Publishers Weekly</i></b><br/>  <br/><b>“Many people have written about the healing power of dialogue. None, however, has put that power to the test under more extreme conditions with greater success than Adam Kahane. Informative, inspiring, and beautifully written.” —David Korten, President of the People-Centered Development Forum, and author of <i>When Corporations Rule the World</i><br/><br/> “This generative dialogue approach offers real opportunities for governments to engage with stakeholders to build trust and create exciting new resolutions to multi-faceted social and governance challenges.” —Clare Beckton, Assistant Deputy Attorney General of Canada</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam Kahane, Peter Senge
      </h2>
      
      <p class="authorDescription body article">Adam Kahane is a leading designer and facilitator of processes through which business, government, and civil society leaders can together solve their toughest problems. He has worked in more than fifty countries, in every part of the world. He is a founding partner of Reos Partners and of Generon Consulting.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3435a634